import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import APIcon from '@alphapoint/apex-web/lib/components/common/APIcon';
import {
  marginNavNotificationSelector,
  marginBorrowerEnabledSelector,
} from '@alphapoint/apex-web/lib/redux/margin/selectors/marginSelectors';
import { futuresEnabledSelector } from '@alphapoint/apex-web/lib/redux/futures/selectors/futuresSelectors';
import { removeMarginNavNotification } from '@alphapoint/apex-web/lib/redux/margin/actions/marginNavNotificationActions';
import { openModal, MODAL_TYPES } from '@alphapoint/apex-web/lib/redux/actions/modalActions';

class PageHeaderNavMenuComponent extends React.Component {
  submenuNavItemsInitialState = {
    Trade: false,
    Yield: false,
    Wallet: false,
  };

  state = {
    ...this.submenuNavItemsInitialState,
    activeSubmenu: null,
  };

  componentDidMount() {
    this.setActiveSubmenu();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setActiveSubmenu();
    }
  }

  setActiveSubmenu = () => {
    const { navItems, location } = this.props;
    let activeSubmenu = null;

    navItems.forEach((item) => {
      if (item.submenuNavItems) {
        item.submenuNavItems.forEach((submenuItem) => {
          if (location.pathname === submenuItem.path) {
            activeSubmenu = item.text;
          }
        });
      }
    });

    this.setState({ activeSubmenu });
  };

  handleNavItemClick = (navItemText, event) => {
    if (navItemText === 'Dashboard') {
      this.props.removeMarginNavNotification();
    }

    if (navItemText === 'Margin' && !this.props.marginEnabled) {
      if (event) event.preventDefault(); // Prevent navigation to Margin exchange page if not enabled
      this.props.openModal(MODAL_TYPES.EXCHANGE_NAV_WARNING, { feature: 'Margin' });
      return;
    }
    if (navItemText === 'Futures' && !this.props.futuresEnabled) {
      if (event) event.preventDefault(); // Prevent navigation to Futures exchange page if not enabled
      this.props.openModal(MODAL_TYPES.EXCHANGE_NAV_WARNING, { feature: 'Futures' });
      return;
    }

    const isSubmenuNavItem = this.submenuNavItemsInitialState[navItemText] !== undefined;

    this.props.handleNavMenuClick(isSubmenuNavItem);

    this.setState((prevState) => ({
      ...this.submenuNavItemsInitialState,
      [navItemText]: !prevState[navItemText],
      activeSubmenu: isSubmenuNavItem ? navItemText : null,
    }));
  };

  render() {
    const { t } = this.props;
    const { navItems, customClass, hasMarginNavNotifications } = this.props;

    return navItems.map((item) => {
      const isActiveSubmenu = this.state.activeSubmenu === item.text;

      const showMarginNavNotification = item.text === 'Dashboard' && hasMarginNavNotifications;

      return (
        <div
          key={item.text}
          className={customClass(`nav-item ${item.submenuNavItems ? 'sub-menu' : ''}`, [
            'hoverable',
            `${this.state[item.text] || isActiveSubmenu ? 'opened' : ''}`,
          ])}>
          <NavLink
            to={item.path}
            onClick={(e) => this.handleNavItemClick(item.text, e)}
            isActive={(match) => match && item.path !== '#'}
            className={customClass('item')}
            activeClassName={customClass('item', ['selected'])}
            id={showMarginNavNotification ? 'dashboard-nav-item' : ''}>
            {showMarginNavNotification && <APIcon name="marginNavNotification" customClass={customClass('icon')} />}
            <span className={customClass(`label ${item.submenuNavItems ? 'submenu-label' : ''}`)}>{t(item.text)}</span>
          </NavLink>
          {item.submenuNavItems && (
            <div className={customClass('sub-menu-item')}>
              <div className="bg-nav-item" />
              <div className={customClass('sub-menu-body')}>
                <ul className={customClass('sub-menu-nav-list')}>
                  {item.submenuNavItems.map((submenuItem) => (
                    <li key={submenuItem.path} className={customClass('sub-menu-nav-list-item')}>
                      <NavLink
                        to={submenuItem.path}
                        onClick={(e) => this.handleNavItemClick(submenuItem.text, e)}
                        isActive={(match) => match && match.isExact && match.url === submenuItem.path}
                        className={customClass('item', ['sub-menu', 'hoverable'])}
                        activeClassName={customClass('item', ['selected'])}>
                        <APIcon name={submenuItem.icon} customClass={customClass('icon')} />
                        <div className={customClass('label-wrapper')}>
                          <span className={customClass('label')}>{t(submenuItem.text)}</span>
                          <span className={customClass('subtitle')}>{t(submenuItem.subtitle)}</span>
                        </div>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      );
    });
  }
}

PageHeaderNavMenuComponent.propTypes = {
  customClass: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  items: PropTypes.array,
};

const mapStateToProps = (state) => ({
  hasMarginNavNotifications: marginNavNotificationSelector(state),
  marginEnabled: marginBorrowerEnabledSelector(state),
  futuresEnabled: futuresEnabledSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  removeMarginNavNotification: () => dispatch(removeMarginNavNotification()),
  openModal: (modalType, payload) => dispatch(openModal(modalType, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(PageHeaderNavMenuComponent)));
